import createAxiosInstance from '../createAxiosInstance';

const THEME_API_URL = import.meta.env.VITE_API_URL_PRODUCT;

if (THEME_API_URL === undefined) {
    throw new Error('Product API URL is not defined');
}

const axios = createAxiosInstance(THEME_API_URL);

export default axios;
